<template>
    <div class="game game-2">
        <TimeCounter
            ref="timeCounter"
            :time="duration"
            @due="onDue"
            @tick="onTick"
        />
        <Score />
        <Question :selected="selected">
            <template v-slot:question>
                <span :class="questionClass(questionConfig)">{{
                    questionConfig.question
                }}</span>
            </template>
            <Reaction
                :question="questionConfig.question"
                :selected="selected"
                :answer="questionConfig.answer"
            />
        </Question>
        <Footer type="game2" :level="$route.params.level" :correct="correct">
            <div ref="lottie" class="lottie" />
        </Footer>
        <AnswerWrapper bottom="3%">
            <div class="selections">
                <div
                    v-for="(selection, index) in questionConfig.options"
                    :key="index"
                    :class="{
                        correct: judgeCorrect(
                            selected,
                            index,
                            questionConfig.answer
                        ),
                        incorrect: judgeIncorrect(
                            selected,
                            index,
                            questionConfig.answer
                        ),
                    }"
                    @click="onAnswer(index)"
                >
                    {{ selection }}
                </div>
            </div>
        </AnswerWrapper>
        <transition name="fade" mode="out-in">
            <PopupWrapper v-if="popup" @ready="onReady" button-color="#3c9c74">
                遊戲採「<strong>選擇題</strong>」，總計<strong
                    >{{ totalQuestions }}題</strong
                >，每次限時{{ duration }}秒，答對<strong
                    >+{{ correctScore }}</strong
                >分，<strong>1秒內</strong>答對分數<strong>{{ "兩倍" }}</strong
                >，剩餘時間<strong
                    >每{{ bonusExchangeConstant }}秒獲得1分</strong
                >
                <template v-if="!isInEvent"
                    >，挑戰累積到一定分數後就可以在「<strong>闖關進度塔</strong>」裡解鎖道具喔！
                </template>
            </PopupWrapper>
        </transition>
    </div>
</template>

<script>
import lottie from 'lottie-web';

import { mapGetters } from 'vuex';
import Question from '@/components/Stage/Game/Components/Game2Question.vue';
import Reaction from '@/components/Stage/Game/Components/Game2Reaction.vue';
import GlobalConfig from '@/config/global';
import Config from '@/config/question/game2';
import mixins from '../mixins';

let anime;

export default {
    components: { Question, Reaction },
    mixins: [mixins],
    data() {
        return {
            config: null,
            bonusExchangeConstant: null,
        };
    },
    computed: {
        ...mapGetters(['isInEvent']),
        questionClass() {
            return (config) => ({
                small: config.question?.length > 30,
            });
        },
    },
    created() {
        this.config = Config;
        this.bonusExchangeConstant = GlobalConfig.bonusExchangeConstant;
    },
    mounted() {
        this.onPreload();
    },
    destroyed() {
        anime.destroy();
    },
    methods: {
        onAnswer(selection) {
            if (this.selected !== undefined) return;
            this.answeredQuestionAmount += 1;
            this.selected = selection;
            this.correct = this.judgeCorrect(
                this.selected,
                selection,
                this.questionConfig.answer,
            );
            this.handleAfterAnswer(this.correct);

            if (this.correct) {
                this.onChangeQuestion(this.config.correctDuration * 1000);
            } else this.onChangeQuestion(this.config.incorrectDuration * 1000);
        },
        setAnimation() {
            anime = lottie.loadAnimation({
                container: this.$refs.lottie, // the dom element that will contain the animation
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: `/lottie/game2/level${this.$route.params.level}/data.json`, // the path to the animation json
            });
        },
        onPreload() {
            this.setAnimation();
            this.$emit('ready');
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../style.scss";

.game-2 {
    > .question {
        font-size: 26px;
        .small {
            font-size: 20px;
        }
    }
    .selections {
        // flex: 1;
        width: 100%;
        overflow: auto;
        font-size: 1.3em;

        > * {
            cursor: pointer;
            margin: auto auto 15px auto;
            border-radius: 30.2px;
            width: 80%;
            height: 40px;
            background-color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            box-sizing: border-box;
        }
        .correct {
            color: #fff;
            background-color: #5ac892;
        }
        .incorrect {
            color: #fff;
            background-color: #cf6300;
        }
    }
}
</style>
